import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StoreService } from '@shared/services/store.service';
import { TrackerService } from '@shared/services/tracker.service';
import { ErrorVM } from './error.viewmodel';

@Component({
  selector: 'app-error',
  templateUrl: './error.html',
  styleUrls: ['./error.scss'],
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { class: 'max-w-full d-flex flex-col justify-center items-center' },
})

/*
  This error page is displayed for /process errors and 
  when user tries to access an unexisting route
*/
export class ErrorComponent implements OnInit {
  private errorVM: ErrorVM;

  constructor(
    private tracker: TrackerService,
    private storeService: StoreService,
    private router: Router
  ) {
    this.errorVM = new ErrorVM(this.tracker, this.storeService, this.router);
  }

  async ngOnInit(): Promise<void> {
    await this.errorVM.onInit();
  }

  continue() {
    this.errorVM.continue();
  }
}
